import type { Option, Sorting } from '@tbitop/ui';
import { Filtering, MultiSelect, MultiValueFilter, useFiltering } from '@tbitop/ui';
import { isEmpty } from 'lodash-es';
import type { ObjektSortierung } from '../../../infrastructure/graphql/__generated__/globalTypes';

export type ObjektSortColumns = keyof typeof ObjektSortierung;
export type ObjektSorting = Sorting<ObjektSortColumns>;

export type ObjektFilters = {
  aufgabentypen?: string[];
  objektnummern?: string[];
  suchbegriff?: string;
};

const defaultObjektSortOptions: Option<ObjektSortColumns>[] = [
  { value: 'Aufgabenanzahl', label: 'Aufgabenanzahl' },
  { value: 'Faelligkeit', label: 'Fälligkeit' },
  { value: 'Name', label: 'Name' },
];

type ObjektFilteringProps = {
  filterValues: ObjektFilters;
  onFilterChange: (values: ObjektFilters) => void;
  className?: string;
  onSortChange: (sorting: ObjektSorting) => void;
  sorting: ObjektSorting;
  aufgabentypen?: Record<string, string>;
  objektSortOptions?: Option<ObjektSortColumns>[];
};

export const Objektfilter = ({ filterValues, sorting, onSortChange, onFilterChange, className, aufgabentypen, objektSortOptions }: ObjektFilteringProps) => (
  <Filtering
    sorting={sorting}
    onSortChange={onSortChange}
    sortOptions={objektSortOptions || defaultObjektSortOptions}
    className={className}
    onFilterValuesChange={onFilterChange}
    filterValues={filterValues}
  >
    {aufgabentypen && <ExpandableFilters aufgabentypen={aufgabentypen}/>}
  </Filtering>
);

type ExpandableFiltersProps = {
  aufgabentypen: Record<string, string>;
};

const ExpandableFilters = ({ aufgabentypen }: ExpandableFiltersProps) => {
  const { filterValues, onSingleFilterChange } = useFiltering<ObjektFilters>();
  return (
    <div className="flex flex-col col-span-4 gap-2">
      <AufgabentypFilter
        aufgabentypen={aufgabentypen}
        value={filterValues.aufgabentypen}
        onChange={value => onSingleFilterChange('aufgabentypen', value)}
      />
    </div>
  );
};


type AufgabentypFilterProps = {
  aufgabentypen: Record<string, string>;
  value: string[] | undefined;
  onChange: (value: string[]) => void;
};

const AufgabentypFilter = ({ aufgabentypen, onChange, value }: AufgabentypFilterProps) => {
  if (isEmpty(aufgabentypen)) {
    return null;
  }

  return (
    <MultiValueFilter
      className="w-full"
      MultiValueFormComponent={MultiSelect}
      value={value}
      onChange={onChange}
      options={aufgabentypen}
      label="Aufgabentyp"
    />
  );
};
